import unit from './util/unit';
import etc from './util/etc';
import struct from './util/struct';
import dom from './util/dom';

/**
 * <b>이 객체는 여러 유틸리티를 포함하는 객체로 싱글턴이기에 인스턴스를 만들 수 없고 메소드만 사용 가능합니다.</b>
 * <pre>
 * 이 객체는 정보가 없이 묶어주는 역활만 하므로 views/util/js/util아래에 있는 메소드들을 같이 보셔야합니다.
 * </pre>
 * 같이 보기 : <br>
 * <a href="./Dom.html">Dom</a>, <a href="./Etc.html">Etc</a>, <a href="./Struct.html">Struct</a>, <a href="./Unit.html">Unit</a>
 */
class Util {
    /**
     * <pre>
     * 이 생성자는 메소드들을 연결시켜줍니다.
     * util에 메소드를 추가시키고 싶다면 util/js/util아래에 새로 소스를 만들고 메소드들을 만든 후 붙혀줍니다.
     * </pre>
     */
    constructor() {
        this.checkValueUnitValid = unit.checkValueUnitValid;
        this.makeUnits = unit.makeUnits;
        this.makeUnit = unit.makeUnit;
        this.percentToFloat = unit.percentToFloat;
        this.checkPercent = unit.checkPercent;
        this.compareArray = unit.compareArray;
        this.makeBorder = unit.makeBorder;
        this.checkOpValid = unit.checkOpValid;
        this.calcAOB = unit.calcAOB;
        this.makeRandomColor = etc.makeRandomColor;
        this.tBind = struct.tBind;
        this.sBind = struct.sBind;
        this.sgBind = struct.sgBind;
        this.saBind = struct.saBind;
        this.makeGlobalId = etc.makeGlobalId;
        this.getOffset = dom.getOffset;
        this.getOffsetFirst = dom.getOffsetFirst;
        this.getOffsetLeft = dom.getOffsetLeft;
        this.getOffsetTop = dom.getOffsetTop;
        this.getOffsetWidth = dom.getOffsetWidth;
        this.getOffsetHeight = dom.getOffsetHeight;
        this.checkValidPostfix = dom.checkValidPostfix;
        this.makeRotate = unit.makeRotate;
        this.addImportant = unit.addImportant;
        this.isLowerCase = etc.isLowerCase;
        this.isUpperCase = etc.isUpperCase;
        this.camelToArray = etc.camelToArray;
        this.pascalToArray = etc.pascalToArray;
        this.snakeToArray = etc.snakeToArray;
        this.macroToArray = etc.macroToArray;
        this.periodToArray = etc.periodToArray;
        this.isAlpha = etc.isAlpha;
        this.isNumber = etc.isNumber;
        this.isPeriodCase = etc.isPeriodCase;
        this.isSnakeCase = etc.isSnakeCase;
        this.isCamelCase = etc.isCamelCase;
        this.isPascalCase = etc.isPascalCase;
        this.getClient = dom.getClient;
        this.makeDate = unit.makeDate;
        this.makeCommaNumber = etc.makeCommaNumber;
         /* From the bottom up; it's abbreviated.*/
        this.mU = unit.makeUnit;
        this.mB = unit.makeBorder;
        this.cA = unit.compareArray;
        this.mRC = etc.makeRandomColor;
        this.addI = unit.addImportant;
        this.isLower = etc.isLowerCase;
        this.isUpper = etc.isUpperCase;
    }
}

export default new Util();